<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="card" :header-classes="{'text-right': isRTL}" style="background: #00011f">
          <h4 slot="header" class="card-title">Races</h4>
          <div class="form-group">
            <label for="date">Date:</label>
            <Datepicker v-model="date" id="date"/>
          </div>
          <div class="table-responsive">
            <race-table :date="date"></race-table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import RaceTable from './Dashboard/RaceTable';
  import Datepicker from 'vuejs-datepicker';

  export default {
    components: {
      RaceTable,
      Datepicker
    },
    data() {
      return {
        date: new Date()
      }
    },
    computed: {
      enableRTL() {
        return this.$route.query.enableRTL;
      },
      isRTL() {
        return this.$rtl.isRTL;
      }
    },
    mounted() {
      this.i18n = this.$i18n;
      if (this.enableRTL) {
        this.i18n.locale = 'ar';
        this.$rtl.enableRTL();
      }
    },
    beforeDestroy() {
      if (this.$rtl.isRTL) {
        this.i18n.locale = 'en';
        this.$rtl.disableRTL();
      }
    }
  };
</script>
<style>
  a {
    color: #ffffff;
    font-weight: 300;
  }
</style>
